<template>
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-alert
          class="ma-4"
          type="warning"
          v-for="item in handleError.items"
          :key="item"
          close-icon
        >
          {{ item }}
        </v-alert>
        <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
          <!-- ========================================= -->
          <!--             Registration form             -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4"
            >{{ $t("registrationForm") }}
          </v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('fullName')"
              v-model="form.fullName"
              :rules="fullNameRules"
              required
              clearable
              outlined
              dense
              autofocus
            ></v-text-field>
          </div>
          <!-- ========================================= -->
          <!--              Configurations               -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4">{{ $t("settings") }} </v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('commission')"
              v-model="form.comission"
              :rules="requiredComission"
              required
              outlined
              dense
              type="number"
              suffix="%"
            ></v-text-field>
          </div>
          <!-- ========================================= -->
          <!--                CredentialS                -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4"
            >{{ $t("credentials") }}
          </v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('login')"
              v-model="form.login"
              :rules="usernameRules"
              required
              clearable
              outlined
              dense
              autocapitalize="off"
            ></v-text-field>

            <template v-if="edit">
              <v-btn @click="editPassword = !editPassword" class="mb-3">
                {{ $t("changePassword") }}
              </v-btn>
            </template>
            <template v-if="editPassword || !edit">
              <v-text-field
                :class="[
                  !form.password || show ? 'show-password' : 'hide-password',
                ]"
                :label="$t('password')"
                v-model="form.password"
                :rules="passwordRules"
                required
                clearable
                outlined
                dense
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>

              <v-text-field
                :class="[
                  !form.confirmPassword || show1
                    ? 'show-password'
                    : 'hide-password',
                ]"
                :label="$t('confirmPassword')"
                v-model="form.confirmPassword"
                :rules="passMatch"
                required
                clearable
                outlined
                dense
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show1 = !show1"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>
            </template>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          v-on:click.prevent="updateRegional"
          type="submit"
          :disabled="!valid || loading"
        >
          {{ $t("toSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  data: () => ({
    // Utils
    valid: false,
    show: false,
    show1: false,
    loading: false,
    editPassword: false,
    // Form data:
    form: {
      // Sector: Registration form
      fullName: "",
      // Sector: Credentials
      login: "",
      password: "",
      confirmPassword: "",
      // Sector: Configurations
      comission: 0.0,
    },

    // Validate Forms:
    fullNameRules: [validate.required, validate.max],

    requiredRules: [validate.required, validate.max],
    requiredComission: [validate.required, validate.negativeNo],
    usernameRules: [
      validate.required,
      validate.usernameMax,
      validate.usernameAz09,
      validate.max,
    ],
    passwordRules: [
      validate.required,
      validate.passRule,
      validate.passCaracter,
      validate.max,
    ],
    required: validate.required,
    // Handle Error:
    handleError: {
      items: [],
    },
    checkPasswordRules: {
      required: true,
    },
    // Edit
    edit: false,
    id_user: "",
  }),
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    // // Repet password
    passMatch() {
      const rules = [];
      let required = this.$t("requiredInput");
      let repeatPassWord = this.$t("repeatThePassword");
      // Required
      if (this.form.confirmPassword) {
        const rule = (v) => !!v || required;
        rules.push(rule);
      }

      // Confirm Password
      if (this.form.password) {
        const rule = (v) => (!!v && v) === this.form.password || repeatPassWord;
        rules.push(rule);
      }

      return rules;
    },
  },
  async mounted() {
    // =================================================== //
    // Translate
    // =================================================== //

    // =================================================== //
    // Add
    // =================================================== //

    if (!this.$route.params.id) {
      return;
    }

    // =================================================== //
    // IF - Edit
    // =================================================== //

    this.edit = true;

    this.id_user = this.$route.params.id;
    let userData = await this.$request.post("/colab/affiliates/getRegional", {
      id_user: this.id_user,
    });

    const { comissao_online, login, nome } = userData.dados;

    //  Sector: Profile
    this.form.fullName = nome;
    //  Sector: Credentials
    this.form.login = login;
    //  Sector: Configurations
    this.form.comission = comissao_online;
  },

  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    //
    // updateRegional: Create or Edit Local Manager.
    async updateRegional() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // Progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      // Body Request Verify Login
      const verifyLogin = {
        domain: this.$localStorage.getItem("user_data").db_name,
        login: this.form.login,
      };

      // Body Form
      const formUpdateRegionalManager = {
        nome: this.form.fullName,
        login: this.form.login,
        password: this.form.password,
        comissao_online: this.form.comission,
      };

      try {
        if (this.edit) {
          Object.assign(formUpdateRegionalManager, { id_user: this.id_user });
        } else {
          // Verify Login:
          const verify = await this.$request.post(
            "main/fetchLogin",
            verifyLogin
          );
          if (verify.length == 0) {
            return;
          }
        }

        // Handle Endpoint
        const updateEndpoint = this.edit
          ? "/colab/affiliates/editregional"
          : "/colab/affiliates/addregional";

        const result = await this.$request.post(
          updateEndpoint,
          formUpdateRegionalManager
        );
        if (result.length == 0) {
          return;
        }

        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });

        if (!this.edit) {
          this.$refs.form.reset();
        }

        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },

    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
